<template>
  <div class="missed-chat">
    <div style="width: 100%; margin-bottom: 20px">
      <template v-if="!webchatAvailable || closed">
        <h3>Webchat is closed today.</h3>
      </template>

      <template v-else>
        <h3 v-if="insideHours">
          Sorry our Cancer Support Advisors are chatting with other clients.
          Please try again later.
        </h3>
        <h3 v-if="!insideHours">
          Webchat is available 9am-5pm, Monday to Friday (excluding public holidays)
        </h3>
      </template>

      <p style="margin-top: 30px">
        {{ insideHours && !closed ? "Or s" : "S" }}ubmit your details below with
        a contact number and preferred time and we will endeavour to phone you
        back.
      </p>
      <p style="margin-top: 30px">
        Submit your details below with a contact number and preferred time and
        we will endeavour to phone you back.
      </p>
      <p>
        We make two attempts to contact you, after such time, if unsuccessful,
        we will leave a message and encourage you to call again.
      </p>
    </div>
    <CallbackForm />
  </div>
</template>

<script>
import CallbackForm from "./callbackForm";
// import Purecloud from '../../api/purecloud'

export default {
  name: "ChatOffline",
  components: { CallbackForm },
  props: {
    insideHours: Boolean,
    webchatAvailable: Boolean,
    closed: Boolean,
  },
  data: () => ({
    submitted: false,
  }),
};
</script>

<style lang="scss">
@use "./_responsive.scss" as *;

.missed-chat {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  @include tablet {
    flex-direction: column;
  }

  @include mobile {
    text-align: center;
  }

  // .details-form {
  //   flex-direction: column;

  //   .md-field { width: 100%; max-width: 600px; }
  // }

  h3 {
    margin-top: 10px;
  }

  p {
    margin-bottom: 0px;
  }
  // .border-left {
  //   border-left: 3px solid $teal;
  //   padding-left: 50px;
  // }

  .missed-left,
  .missed-right {
    width: 47%;

    @include tablet {
      width: 100%;
      display: block;
    }
  }

  .missed-left {
    @include tablet {
      width: 100%;
      // height: 130px;
      text-align: center;
      margin-bottom: 30px;
    }

    svg {
      // position: absolute;
      height: 380px;
      width: 100%;
      top: 30px;
      left: 0;

      @include tablet {
        top: 20px;
      }
    }
  }
}
</style>
